<template>
  <v-card tile width="1023px" height="100vh">
    <v-navigation-drawer
      id="colornav"
      width="1023px"
      fixed
      dark
      floating
      permanent
      dir="rtl"
    >
      <v-list shaped dense>
        <!-- Logo -->
        <v-card-title class="justify-center pa-1">
          <router-link :to="'/'">
            <v-avatar size="75">
              <img
                :aspect-ratio="1 / 1"
                src="@/assets/namya_logo.png"
                alt="Logo"
              />
            </v-avatar>
          </router-link>
        </v-card-title>
        <v-card-title
          class="justify-center pa-1"
          style="font-size: 13px !important; font-weight: 500"
          >نامیا</v-card-title
        >
        <v-card-title
          class="justify-center pa-1"
          style="font-size: 12px !important; font-weight: 500"
          >دستیار هوشمند کسب و کار ها</v-card-title
        >
        <!-- Menu -->
        <v-list>
          <v-list-item
            color="success"
            class="item"
            v-for="(item, i) in listItems"
            :key="i"
            :exact="true"
            :to="{ name: item.name, params: { name: customers.url } }"
            :target="item.name == 'order' ? '_blank' : ''"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                style="font-size: 12px !important; font-weight: 200"
                >{{ item.title }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- <v-divider v-show="location == 'namya.ir'"></v-divider> -->
        <v-divider></v-divider>
        <!-- <v-row v-show="location == 'namya.ir'" class="ma-0" align="center"> -->
        <v-row class="ma-0" align="center">
          <v-col class="pa-0" cols="6" align="center">
            <a
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=228127&Code=SX9GI7jjWs9e6V42foSg"
              ><img
                referrerpolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=228127&Code=SX9GI7jjWs9e6V42foSg"
                alt=""
                style="cursor: pointer"
                height="90"
                width="55"
                Code="SX9GI7jjWs9e6V42foSg"
            /></a>
          </v-col>
          <v-col cols="6" align="center">
            <picture>
              <source
                type="image/webp"
                srcset="@/assets/images/checked/kasbokar.png"
              />
              <v-img
                :aspect-ratio="16 / 9"
                class="m-1 cursor images"
                height="90"
                width="55"
                src="@/assets/images/checked/kasbokar.png"
              ></v-img>
            </picture>
          </v-col>
          <v-col cols="6" align="center">
            <picture>
              <source
                type="image/webp"
                srcset="@/assets/images/checked/rezi.png"
              />
              <v-img
                :aspect-ratio="16 / 9"
                class="m-1 cursor images"
                height="75"
                width="55"
                src="@/assets/images/checked/rezi.png"
              ></v-img>
            </picture>
          </v-col>
          <v-col cols="6" align="center">
            <v-btn
              class="px-0"
              plain
              text
              target="_blank"
              rel="noopener noreferrer"
              href="https://yazd.irannsr.org/fa/trade_unit/2458970/swd_id/106788/%D8%A7%D8%B9%D8%B6%D8%A7%DB%8C-%D8%AD%D9%82%D9%88%D9%82%DB%8C-%D9%86%D8%A7%D9%85%DB%8C%D8%A7%D8%A8-%D9%86%D9%88%DB%8C%D9%86-%D9%87%D9%88%D8%B4%D9%85%D9%86%D8%AF.html"
            >
              <picture>
                <source
                  type="image/webp"
                  srcset="@/assets/images/checked/irannsr.png"
                />
                <v-img
                  :aspect-ratio="16 / 9"
                  class="m-1 cursor images"
                  height="75"
                  width="90"
                  src="@/assets/images/checked/irannsr.png"
                ></v-img>
              </picture>
            </v-btn>
          </v-col>
        </v-row>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
export default {
  name: "navigationBar",
  data() {
    return {
      listItems: [
        {
          id: 1,
          icon: "mdi-home",
          title: "خانه",
          name: "home",
        },
        {
          id: 2,
          icon: "mdi-cable-data",
          title: "تماس با ما",
          name: "aboutus",
        },
        {
          id: 3,
          icon: "mdi-clipboard-list-outline",
          title: "ثبت سفارش",
          name: "order",
        },
        {
          id: 4,
          icon: "mdi-cog",
          title: "امکانات",
          name: "feature",
        },
        {
          id: 5,
          icon: "mdi-image-album",
          title: "گالری",
          name: "gallery",
        },
        {
          id: 6,
          icon: "mdi-book-open-page-variant-outline",
          title: "کاتالوگ",
          name: "catalog",
        },
        {
          id: 7,
          icon: "mdi-panorama-variant-outline",
          title: "تور مجازی",
          name: "virtual_tour",
        },
        // {
        //   id: 5,
        //   icon: "mdi-comment-processing-outline",
        //   title: "نظرات و پیشنهادات",
        //   name: "comments",
        // },
      ],
      // booths: [],
      value: 1,
      location: window.document.location.host.replace("www.", ""),
    };
  },
  props: { customers: {} },
  created() {
    // this.localBooth();
  },
  methods: {
    // async localBooth() {
    //   let response = await this.axios
    //     .get("https://namya.ir/api/v1/businesses/booths/48")
    //     .then((response) => {
    //       this.booths = response.data.data;
    //       localStorage.setItem("ID", response.data.data.id);
    //     })
    //     .catch((error) => {});
    // },
  },
};
</script>

<style scoped>
#colornav {
  background-color: #2b2e33;
}

.v-input--dense > .v-input__control > .v-input__slot {
  margin-bottom: -13px;
}

.v-application--is-rtl .v-list-item__action:first-child,
.v-application--is-rtl .v-list-item__icon:first-child {
  margin-left: 15px;
}

.v-list {
  padding-left: 10px;
}

.v-application--is-rtl .v-list.v-sheet--shaped {
  padding-left: 0px;
}

.v-navigation-drawer {
  left: inherit !important;
  max-width: 16.7%;
}
</style>
